import { useCacheStore } from '@/stores/cache-store'
import { keyBuilderService } from '../../services/key-builder'
import { invalidateByPrefix } from './invalidate-by-prefix'

/**
 * Belirli bir öneke ve parametrelere sahip cache girdisini siler
 * @param {string} prefix - Cache anahtarı için önek
 * @param {Object} params - Silinecek parametreler
 */
export const invalidate = (prefix, params = {}) => {
  const cacheStore = useCacheStore()
  
  // Eğer params boş ise, tüm prefix'i sil
  if (Object.keys(params).length === 0) {
    return invalidateByPrefix(prefix)
  }
  
  // Belirli parametre değerlerine sahip key'i sil
  const key = keyBuilderService.build(prefix, params)
  cacheStore.delete(key)
  
  // İstatistik için
  if (typeof window !== 'undefined' && window.__CACHE_STATS__) {
    window.__CACHE_STATS__.invalidations = (window.__CACHE_STATS__.invalidations || 0) + 1
  }
  
  if (process.env.NODE_ENV === 'development') {
    console.log(`🗑️ Cache INVALIDATE: ${key}`, { params })
  }
}